import axios from "axios";
import { api } from "./api_route";

// Organization Master

export const organizationZoneRecord = async (values) => {
  try {
    const response = await axios.get(`${api}/organizationZones/all`);
    return {
      success: true,
      data: response.data?.data,
      message: "Zones fetched successfully",
    };
  } catch (error) {
    console.error("Organization zone check error:", error);
    throw error;
  }
};

export const organizationZoneFind = async (values) => {
  try {
    const response = await axios.get(`${api}/organizationZones/check`, {
      params: {
        organizationID: values.organizationID,
        zoneName: values.zoneName.trim(),
      },
    });
    return {
      isUnique: response.data.isUnique,
      exists: !response.data.isUnique,
    };
  } catch (error) {
    console.error("Organization zone check error:", error);
    throw error; // Important to throw for proper error handling
  }
};

export const organizationZoneCreate = async (values) => {
  try {
    const response = await axios.post(
      `${api}/organizationZones/create`,
      values
    );
    return {
      success: true,
      data: response.data,
      message: "Zone created successfully",
    };
  } catch (error) {
    console.error("Organization zone creation error:", error);
    throw error.response?.data || error;
  }
};

export const organizationZoneUpdate = async (values) => {
  try {
    const response = await axios.put(
      `${api}/organizationZones/update/${values.id}`,
      values
    );
    return {
      success: true,
      data: response.data,
      message: "Zone updated successfully",
    };
  } catch (error) {
    console.error("Organization zone update error:", error);
    throw error.response?.data || error;
  }
};

export const organizationZoneStatus = async (zoneId) => {
  try {
    const response = await axios.patch(
      `${api}/organizationZones/${zoneId}/status`
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling zone status:", error);
    throw error;
  }
};

export const organizationZoneDelete = async (zoneId) => {
  try {
    const response = await axios.delete(`${api}/organizationZones/${zoneId}`);

    return response.data;
  } catch (error) {
    throw {
      ...error,
      isAxiosError: true,
      response: error.response || {
        status: 500,
        data: { message: "Network error occurred" },
      },
    };
  }
};
